import { buildStyledComponent } from 'decisiv-ui-utils';
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { omit } from 'lodash';
import styled from 'styled-components';

function UnstyledIcon(props) {
  const iconProps = omit(props, ['theme', 'modifiers']);
  return <FontAwesome {...iconProps} />;
}

const modifierConfig = {
  disabled: () => `
    opacity: 0.5;
  `,
};

const styles = '';

export default buildStyledComponent('SearchIcon', styled(UnstyledIcon), styles, { modifierConfig });



// WEBPACK FOOTER //
// ./components/Search/SearchButton/SearchIcon.js